import ru from './ru.json';
import en from './en.json';
export const softwareI18nResources = {
    ru,
    en,
};
